import { ModelRow } from "@mcleod/core";
import { DataSourceMode } from "@mcleod/components";
import { AutogenLayoutDeleteStopCompareItems } from "./autogen/AutogenLayoutDeleteStopCompareItems";

export class DeleteStopCompareItems extends AutogenLayoutDeleteStopCompareItems {
    private _compareItems: ModelRow[];
    private _key: string;

    override onLoad(): void | Promise<void> {
        this.tableCompareItems.dataSource = this.sourceEdiCompareItem;
    }

    public async setupTableData(data: ModelRow[]) {
        this._compareItems = data;
        const newTable = this.filterTable();
        if (newTable != null) {
            if (newTable.length == 0) {
                this.tableCompareItems.visible = false;
            } else {
                this.tableCompareItems.dataSource.setRowsAndMode(DataSourceMode.NONE, newTable);
            }
        }
    }

    private filterTable(): ModelRow[] {
        let newTable = [];
        if (this._compareItems?.length > 0) {
            const changeType = this._compareItems[0].get("change_type");
            if (changeType == "OS") {
                newTable = this._compareItems.filter(value => {
                    const sourceValue = value.get("target_value");
                    if (sourceValue !== null && sourceValue !== "" && sourceValue !== undefined) {
                        return value;
                    }
                });
            }
            else {
                newTable = this._compareItems;
            }
        } else {
            newTable = this._compareItems;
        }
        return newTable;
    }
}
